/* eslint-disable */
import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Taken from https://www.ryadel.com/en/javascript-remove-xml-invalid-chars-characters-string-utf8-unicode-regex/
// Updated to support Safari which has problems with `u` flag
const INVALID_CHARS_REGEX_FULL =
  /[\x00-\x08\x0B\x0C\x0E-\x1F\uD800-\uDFFF\uFFFE\uFFFF]/gu
const INVALID_CHARS_REGEX_SIMPLE = /[\x00-\x08\x0B\x0C\x0E-\x1F\uFFFE\uFFFF]/g

const useUnicodeFlag = (() => {
  const tester = "🛒"
  try {
    // Test if the u flag works correctly with emoji
    const testRegex = /[\x00-\x08]/gu
    return tester.replace(INVALID_CHARS_REGEX_FULL, "?") === tester
  } catch (e) {
    return false
  }
})()

export function stripInvalidXMLChars(text: string): string {
  const regexp = useUnicodeFlag
    ? INVALID_CHARS_REGEX_FULL
    : INVALID_CHARS_REGEX_SIMPLE
  return text.replace(regexp, "?")
}
